import { Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { OfferType } from 'legacy/events/types';
import KickbackKindButton from '../KickbackKindButton';
import classnames from 'classnames';
import styles from 'legacy/common/components/form/Form.module.scss';
import SelectDropdown from 'components/SelectDropdown';

const Reward = () => {
  const { t } = useTranslation('events');
  const { values, setFieldValue, errors } = useFormikContext<OfferType>();
  const kickbackRewards = values.rewards.kickbackRewards;
  const handleChange = (value: string) => {
    setFieldValue('rewards.kickbackRewards.kind', value);
  };
  const hasActiveContract = values.contracts?.length > 0;

  return (
    <div>
      <div className="mt-6">
        <div className="text-[16px] text-[#202020] font-bold">{t('settings.promoterOffers.offerForm.kickback')}</div>
        <div className="text-sm mt-2 text-[#575757] font-normal">
          {t('settings.promoterOffers.offerForm.kickbackDescription')}
        </div>
      </div>
      <div className="mt-4 flex flex-row">
        <Field
          id="kind"
          name="kind"
          label={t('settings.promoterOffers.offerForm.discountType')}
          render={() => (
            <KickbackKindButton
              kind={kickbackRewards.kind}
              handleChange={handleChange}
              disabled={hasActiveContract}
            />
          )}
          className="flex"
        />
        <Field
          id="amount"
          name="amount"
          type="number"
          label={t('settings.promoterOffers.offerForm.discountAmount')}
          disabled={hasActiveContract}
          placeholder={
            kickbackRewards.kind === 'percentage' 
              ? t('settings.promoterOffers.offerForm.percentagePlaceholder')
              : t('settings.promoterOffers.offerForm.dollarPlaceholder')
          }
          value={kickbackRewards.value}
          onChange={(e) =>
            setFieldValue('rewards.kickbackRewards.value', e.target.value)
          }
          className={classnames(
            'border-1 border-[#DCDCDC] rounded-md flex ml-2 max-w-[100px] px-2',
            {
              [styles.errorField]: errors.rewards?.kickbackRewards?.value
            }
          )}
        />

        <div className="flex-1 ml-2">
          <SelectDropdown
            onChange={(value) =>
              setFieldValue(
                'rewards.kickbackRewards.saleConditions.unit',
                value
              )
            }
            value={kickbackRewards.saleConditions.unit}
            data={[
              { value: 'ticket', label: t('settings.promoterOffers.offerForm.perTicket') }
            ]}
            textValueStyle={dropdownStyle}
            controlStyle={controlStyle}
          />
        </div>
      </div>
      {errors.rewards?.kickbackRewards?.value && (
        <div className={classnames(styles.error)}>
          {errors.rewards?.kickbackRewards?.value}
        </div>
      )}
    </div>
  );
};

const dropdownStyle = {
  color: '#202020',
  fontWeight: 400,
  fontSize: 14
};

const controlStyle = {
  borderColor: '#DCDCDC'
};

export default Reward;
